import { createHash } from '@/app/lib/converters/productconverter';

export function normalizeAdditionalImages(additionalImages: string[]): string[] {
  return additionalImages
    .map((item) => {
      const splitItems = item.split(',http');
      return splitItems.map((splitItem, index) => (index !== 0 ? 'http' + splitItem : splitItem));
    })
    .flat()
    .filter(Boolean);
}

export function convertAdditionalImages(additional_images: string[], createHashes = true): string[] {
  const shouldNormalizeImages = additional_images.some((image) => image.includes(',http'));
  const images = shouldNormalizeImages ? normalizeAdditionalImages(additional_images) : additional_images;

  return createHashes ? createMD5Hashes(images) : images;
}

export function getImagePath(imageHash: string, locale: string, retailerId: number, productId: string, large: boolean) {
  return `${process.env.NEXT_PUBLIC_CDN}/product_images/${locale}/${retailerId}/${productId}/${imageHash}_${
    large ? 'xxl' : 'small'
  }.webp`;
}

export function getPLPThumbnailPath(imageHash: string, locale: string, retailerId: number, productId: string, mode: string = 'small_portrait') {
  return `${
    process.env.NEXT_PUBLIC_CDN
  }/product_images/${locale}/${retailerId}/${productId}/${imageHash}_${mode}.webp`;
}

function createMD5Hashes(additional_images: string[]) {
  return additional_images.map((image) => createHash(image)).filter((_) => _);
}
